<template>
    <v-radio-group
        v-model="selectItem"
        class="pa-0 ma-0"
        :disabled="isDisabled"
        :rules="[isRequired ? rules.required : rules.alwaysValid]"
    >
        <v-radio
            v-for="(item, fieldIndex) in getSelectItemsArray(field.select_items)"
            :key="fieldIndex"
            :name="'customize-field-' + field.name"
            color="accent"
            class="pt-1 pb-1"
            :value="item"
            @click="setRadioButtonCheck"
        >
            <template v-slot:label>
                <div
                    class="pt-1 pb-1 pl-6 font-weight-bold text-body-2"
                    :class="`${$options.name}__ListBodyText`"
                    style="white-space: pre-wrap; word-break: break-all"
                    v-text="item"
                />
            </template>
        </v-radio>
    </v-radio-group>
</template>

<script lang="ts">
import { mixins } from 'vue-class-component';
import { Vue, Component, Emit, Prop, Watch } from 'vue-property-decorator';
import type { TemplateCustomizeField } from '../../store/modules/application_form_template/types';
import InputValidation from '../../mixins/InputValidation';

@Component({
    name: 'CustomizedFieldRadioButton',
})
export default class CustomizedFieldRadioButton extends mixins(InputValidation) {
    @Prop({ default: undefined }) readonly field: TemplateCustomizeField;
    @Prop({ default: undefined }) readonly value: string | undefined;
    @Prop({ default: false }) readonly disabled: boolean;

    // v-modelにselectItemを設定しているので、値に変更があった場合、親コンポーネントのclickイベントで変更値を設定する(immediate: trueで変更なしでも一度実行される)
    @Watch('selectItem', { immediate: true })
    onSelectItemChanged(val: string): void {
        this.$emit('click', this.id, val);
    }

    // 初期値の設定
    selectItem: string = this.initialValue;

    /**
     * getters
     */
    get isRequired(): boolean {
        return this.field.required;
    }

    get isDisabled(): boolean {
        return this.disabled;
    }

    get initialValue(): string {
        // 値が定義なしの場合、設定値として選択項目初期値を返す
        if (this.value === undefined) {
            return this.field.default_input;
        }

        return this.value;
    }

    get id(): number {
        return this.field.id;
    }

    /**
     * methods
     */
    getSelectItemsArray(val: string): Array<string> {
        if (!val) return [];
        return val.split(',');
    }

    // clickイベントで呼び出すことで、同じラジオボタンをクリックした場合、チェックが外れるようにしている
    setRadioButtonCheck(): void {
        // 同一項目名の設定が考えられるため、nameで絞り込む
        const radioButtons = document.querySelectorAll(
            'input[type="radio"][name="customize-field-' + this.field.name + '"]'
        );

        // 2回続けてクリックした場合はチェックを外す
        radioButtons.forEach(radioButton => {
            if (
                radioButton.getAttribute('value') === this.selectItem &&
                radioButton.getAttribute('aria-checked') === 'true'
            ) {
                radioButton.setAttribute('aria-checked', 'false');
                this.selectItem = '';
            }
        });
    }
}
</script>
